import { connect } from 'react-redux';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { callSelectors } from '@lifesize/nucleus';
import { openFullScreenModal } from 'actions/FullScreenModal';
import { toggleMinimized } from 'actions/InCall/InCallVideo';
import { SCHEDULE_MODAL } from 'constants/ScheduleModal';
import { START_CALL_MODAL } from 'constants/StartCallModal';
import Welcome from 'components/Welcome/Welcome';
import { isCallConnected } from 'utils/call-utils';

function mapDispatchToProps(dispatch, ownProps) {
  return {
    returnToCall: () => dispatch(toggleMinimized(ownProps.history.push)),
    openCallModal: () => {
      dispatch(openFullScreenModal(START_CALL_MODAL));
    },
    openScheduleModal: () => {
      dispatch(openFullScreenModal(SCHEDULE_MODAL));
    }
  };
}

function mapStateToProps(state) {
  const activeCall = callSelectors.activeCallSelector(state);
  return {
    isCallConnected: isCallConnected(activeCall),
    activeCall,
    name: _get(state, 'nucleus.userProfile.name'),
    loginCount: _get(state, 'app.jwt.loginCount')
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Welcome));
